import {Role} from './Role';

export class Session {

  public token?: string;
  public roles: Role[];
  public role?: Role;

  constructor(roles: Role[], token?: string, role?: Role) {
    this.token = token;
    this.roles = roles;
    this.role = role;
  }

  isValid(): boolean {
    return this.token != null && this.token.length > 0;
  }

  isAdmin(): boolean {
    return this.roles && this.role == Role.Admin && this.roles.includes(this.role);
  }

  isHost(): boolean {
    return this.roles && this.role == Role.Host && this.roles.includes(this.role);
  }

  isCoordinator(): boolean {
    return this.roles && this.role == Role.Coordinator && this.roles.includes(this.role);
  }

  isTeacher(): boolean {
    return this.roles && this.role == Role.Teacher && this.roles.includes(this.role);
  }

  isStudent(): boolean {
    return this.roles && this.role == Role.Student && this.roles.includes(this.role);
  }

  isParticipant(): boolean {
    return this.roles && this.role == Role.Participant;
  }
}
